import React from 'react';
import PropTypes from 'prop-types';
import { createRefetchContainer, graphql } from 'react-relay';
import { Translate } from '@hydra/common/components';
import get from 'lodash/get';

import FilterContainer from '@hydra/routes/crawler/components/FilterContainer';
import FilterCheckboxes from '@hydra/routes/crawler/components/FilterCheckboxes';
import FilterString from '@hydra/routes/crawler/components/FilterString';
import { withFilters } from '@hydra/routes/crawler/components/withFilters';

import CrawlerTable from '@hydra/routes/crawler/components/CrawlerTable';
import DeepPagesRow from '../DeepPagesRow';

export class DeepPagesTable extends React.Component {
  static propTypes = {
    relay: PropTypes.object,
    project: PropTypes.shape({
      crawl: PropTypes.shape({
        indexingCategory: PropTypes.shape({
          DeepPages: PropTypes.shape({
            count: PropTypes.number,
            edges: PropTypes.arrayOf(
              PropTypes.shape({
                node: PropTypes.object
              })
            )
          })
        })
      })
    }).isRequired,
    offset: PropTypes.number,
    limit: PropTypes.number
  }

  render () {
    const toggleFilter = get(this.props.project, 'crawls.edges[0].node.countTypesDeepPages', [])
      .map(v => ({ identifier: v.type, ...v }));

    return (
      <>
        <FilterContainer>
          <FilterCheckboxes
            onChange={this.props.onGraphQLCheckboxInputChange('typeFilters', toggleFilter)}
            checkedItems={this.props.filters.typeFilters}
            groups={toggleFilter}
            name='typeFilters'
            label={<Translate content='crawler_crawl_deep_page_depth' />}
          />

          <FilterString
            onChange={this.props.onGraphQLInputChange('sourceUrl')}
            value={this.props.filters.sourceUrl}
            name='sourceUrl'
            label={<Translate content='crawler_deep_page_source_url' />}
          />

          <FilterString
            onChange={this.props.onGraphQLInputChange('errorUrl')}
            value={this.props.filters.errorUrl}
            name='errorUrl'
            label={<Translate content='crawler_deep_page_error_url' />}
          />
        </FilterContainer>
        <CrawlerTable {...this.props} category='httpStatusCategory' section='deepPages'>
          <CrawlerTable.TableHead>
            <Translate content='crawler_crawl_deep_page_depth' size='1' />
            <Translate content='crawler_deep_page_source_url' size='5' />
            <Translate content='crawler_deep_page_error_url' size='6' />
          </CrawlerTable.TableHead>
          <CrawlerTable.Body component={DeepPagesRow} />
        </CrawlerTable>
      </>
    );
  }
}

const WithFiltersTable = (withFilters)(DeepPagesTable);

export default createRefetchContainer(
  WithFiltersTable,
  {
    project: graphql`
      fragment DeepPagesTable_project on Project
      @argumentDefinitions(
        offset: {type: "Int", defaultValue: 0},
        limit: {type: "Int", defaultValue: 20},
        errorUrl: {type: "TextFilters", defaultValue: { operator: AND, values: [] }}
        sourceUrl: {type: "TextFilters", defaultValue: { operator: AND, values: [] }}
        depthOrder: {type: "Int", defaultValue: -1}
        typeFilters: {type: "[String]", defaultValue: []}
      ) {
        host,
        crawls (offset: 0, limit: 1) {
          edges {
            node {
              countTypesDeepPages (errorUrl: $errorUrl, sourceUrl: $sourceUrl) {
                type,
                count,
                severity
              },
              deepPages (
                offset: $offset,
                limit: $limit,
                sourceUrl: $sourceUrl,
                depthOrder: $depthOrder,
                errorUrl: $errorUrl,
                typeFilters: $typeFilters,
              ) {
                count
                edges {
                  node {
                    ...DeepPagesRow_issue
                  }
                }
              }
            }
          }
        }
      }
    `
  },
  graphql`
      query DeepPagesTable_RefetchQuery(
        $offset: Int,
        $limit: Int,
        $depthOrder: Int,
        $sourceUrl: TextFilters,
        $errorUrl: TextFilters,
        $typeFilters: [String],
        $host: String!
      ) {
        project (host: $host) {
          ...DeepPagesTable_project @arguments(
            offset: $offset,
            limit: $limit,
            sourceUrl: $sourceUrl,
            errorUrl: $errorUrl,
            typeFilters: $typeFilters,
            depthOrder: $depthOrder
          )
        }
      }
    `
);
